export default "__VITE_ASSET__7pI3zizb__"